function getType(context) {
  return context.$route.path.includes('routecontrols') ? 'tc' : 'site';
}

const privs = {
  site: 'pr_site',
  tc: 'pr_tc'
};

const urls = {
  site: '/sites/statusupdates',
  tc: '/routecontrols/statusupdates'
};

const filterNames = {
  site: 'sitestatusupdates',
  tc: 'tcstatusupdates'
};

const getTableFields = {
  site: [
    {
      text: 'Rapport',
      value: 'report_code',
      width: '15%',
      link: '/sites/reports/{sitereport_id}'
    },
    {
      text: 'Site',
      value: 'serial_nr',
      width: '12.5%',
      link: '/sites/sites/{site_id}'
    },
    {
      text: 'Installatienummer',
      value: 'installation_nr',
      width: '12.5%'
    },
    {
      text: 'Datum',
      value: 'created_timestamp',
      width: '12.5%',
      filter: 'date'
    },
    {
      text: 'Beschrijving',
      value: 'description',
      width: '20%'
    },
    {
      text: 'Toezichter',
      value: 'supervisor_name',
      width: '15%'
    },
    {
      text: 'Actie EMT',
      value: 'action_emt',
      filter: 'boolean-string',
      align: 'center',
      sortable: false,
      width: '7.5%'
    },
    {
      text: 'Afgehandeld',
      value: 'state',
      filter: 'boolean',
      align: 'center',
      sortable: false,
      width: '7.5%'
    }
  ],
  tc: [
    {
      text: 'Rapport',
      value: 'report_code',
      width: '15%',
      link: '/routecontrols/reports/{sitereport_id}'
    },
    {
      text: 'Traject Controle',
      value: 'serial_nr',
      width: '12.5%',
      link: '/routecontrols/routecontrols/{site_id}'
    },
    {
      text: 'Datum',
      value: 'created_timestamp',
      width: '12.5%',
      filter: 'date'
    },
    {
      text: 'Beschrijving',
      value: 'description',
      width: '20%'
    },
    {
      text: 'Toezichter',
      value: 'supervisor_name',
      width: '15%'
    },
    {
      text: 'Actie EMT',
      value: 'action_emt',
      filter: 'boolean-string',
      align: 'center',
      sortable: false,
      width: '7.5%'
    },
    {
      text: 'Afgehandeld',
      value: 'state',
      filter: 'boolean',
      align: 'center',
      sortable: false,
      width: '7.5%'
    }
  ]
};

export default {
  priv(context) {
    return privs[getType(context)];
  },
  overviewTitle: 'Status Aanpassingen',
  url(context) {
    return urls[getType(context)];
  },
  apiUrl: '/sitestatusupdates/',
  sortBy: ['created_timestamp'],
  sortDesc: [true],
  addRecord: false,
  deletable: false,
  editable: false,
  filterName(context) {
    return filterNames[getType(context)];
  },
  quickFilter: {
    text: 'Zoeken',
    value: 'misc_search',
    type: 'text'
  },
  advancedSearchFields: [
    {
      text: 'Toezichter',
      value: 'supervisor_id',
      type: 'optionList',
      optionListName: 'supervisors'
    },
    {
      text: 'Periode van',
      value: 'date_start',
      type: 'date'
    },
    {
      text: 'Periode tot',
      value: 'date_end',
      type: 'date'
    },
    {
      text: 'Afgehandeld',
      value: 'state',
      type: 'optionList',
      optionList: [
        {
          value: 0,
          text: 'Nee'
        },
        {
          value: 1,
          text: 'Ja'
        }
      ]
    }
  ],
  tableFields(context) {
    return getTableFields[getType(context)];
  }
};
